export const cosiekTable = [
  { caption: 'Nazwa', get: (row) => row.nazwas, align: 'left', maximize: true}
]

